var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"osc-table"},[_c('table',{staticClass:"table"},[_c('thead',[_vm._t("thead")],2),_c('tbody',[_vm._t("tbody")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }